export interface Country {
  code: string;
  name: string;
  example: string;
  flagCode: string;
}

export const countries: Country[] = [
  { code: "+1", name: "Estados Unidos", example: "201 555 0123", flagCode: "us" },
  { code: "+34", name: "España", example: "612 34 56 78", flagCode: "es" },
  { code: "+52", name: "México", example: "55 1234 5678", flagCode: "mx" },
  { code: "+57", name: "Colombia", example: "300 123 4567", flagCode: "co" },
  { code: "+54", name: "Argentina", example: "11 2345 6789", flagCode: "ar" },
  { code: "+51", name: "Perú", example: "912 345 678", flagCode: "pe" },
  { code: "+503", name: "El Salvador", example: "7012 3456", flagCode: "sv" },
  { code: "+502", name: "Guatemala", example: "5555 1234", flagCode: "gt" },
  { code: "+505", name: "Nicaragua", example: "2222 1234", flagCode: "ni" },
  { code: "+506", name: "Costa Rica", example: "8888 1234", flagCode: "cr" },
  { code: "+507", name: "Panamá", example: "600 1234", flagCode: "pa" },
  { code: "+55", name: "Brasil", example: "11 91234 5678", flagCode: "br" },
  { code: "+56", name: "Chile", example: "9 1234 5678", flagCode: "cl" },
  { code: "+44", name: "Reino Unido", example: "07123 456789", flagCode: "gb" },
  { code: "+33", name: "Francia", example: "06 12 34 56 78", flagCode: "fr" },
  { code: "+49", name: "Alemania", example: "0151 23456789", flagCode: "de" },
  { code: "+39", name: "Italia", example: "345 678 9012", flagCode: "it" },
  { code: "+81", name: "Japón", example: "090 1234 5678", flagCode: "jp" },
  { code: "+61", name: "Australia", example: "0412 345 678", flagCode: "au" },
  { code: "+91", name: "India", example: "91234 56789", flagCode: "in" },
  { code: "+86", name: "China", example: "138 0013 8000", flagCode: "cn" },
];

export const countryCodeMap: Record<string, string> = countries.reduce((acc, country) => {
  acc[country.flagCode] = country.flagCode.toUpperCase();
  return acc;
}, {} as Record<string, string>);
